<template>
  <!-- <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar> -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">
              <span data-tour-step="1">Balas Berdasarkan Kata Kunci</span>
            </h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/index">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/automation/text-reply/list"
                  >Balas Otomatis</router-link
                >
              </li>
              <li class="breadcrumb-item active">
                Balas Berdasarkan Kata Kunci
              </li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a
              data-tour-step="2"
              ref="formBc"
              class="btn add-btn"
              @click="showBroadcast(true)"
              href="#"
              data-toggle="modal"
              data-target="#add_form"
            >
              <i class="fa fa-plus"></i> Tambah
            </a>
          </div>
          <a
            v-show="false"
            ref="formBcEdit"
            class="btn add-btn"
            @click="showBroadcast(false)"
            href="#"
            data-toggle="modal"
            data-target="#add_form"
          >
            <i class="fa fa-whatsapp"></i> Edit
          </a>
        </div>
      </div>

      <div class="row" v-show="false">
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div class="card dash-widget">
            <div class="card-body">
              <span class="dash-widget-icon">
                <i class="fa fa-android"></i>
              </span>
              <div class="dash-widget-info">
                <h3>
                  <span
                    v-if="numPendingTransfer > 0"
                    class="badge badge-warning"
                  >
                    {{ numPendingTransfer }}
                  </span>
                  <span v-else>
                    {{ numPendingTransfer }}
                  </span>
                </h3>
                <span>
                  <router-link :to="'/automation/smart-reply-transfer/list'"
                    >Pending Transfer Auto Reply</router-link
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Header -->
      <div class="row" v-show="false">
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
          <ul class="nav float-right custom-menu">
            <li class="dropdown dropdown-action">
              <a
                href
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  @click.prevent="tourShow"
                  class="dropdown-item"
                  href="javascript:void(0)"
                  >Tour Guide</a
                >
                <a
                  target="_blank"
                  class="dropdown-item"
                  href="https://www.youtube.com/watch?v=9h84laHdtCE&ab_channel=waajoindonesia"
                  >Tutorial Video</a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Search Filter -->
      <div class="row filter-row" data-tour-step="3">
        <div class="col-sm-6 col-md-3">
          <div class="form-group">
            <!-- <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.license_id"
                  type="text"
                />
                <label class="focus-label">License ID</label>-->

            <multiselect
              v-model="selectedContact"
              id="ajax"
              label="license_name"
              track-by="id"
              :placeholder="''"
              :multiple="true"
              open-direction="bottom"
              :custom-label="customLabel"
              :options="contactOptions"
              :searchable="true"
              :loading="isLoading"
              :internal-search="false"
              :close-on-select="false"
              :options-limit="300"
              :limit="3"
              :limit-text="limitText"
              :max-height="600"
              :show-no-results="true"
              :hide-selected="true"
              @search-change="asyncFind"
              :show-labels="false"
            >
              <template slot="option" slot-scope="{ option, remove }">
                <span
                  >{{
                    option.license_name +
                    " (" +
                    option.license_phone_number +
                    ")"
                  }}
                  <i
                    :class="{
                      'text-success': option.is_online_status == 1,
                      'text-danger': option.is_online_status == 0,
                    }"
                    :title="option.is_online_status == 1 ? 'Online' : 'Offline'"
                    class="fa fa-signal"
                  ></i>
                </span>
              </template>
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span
                    >{{
                      option.license_name +
                      " (" +
                      option.license_phone_number +
                      ")"
                    }}
                    <i
                      :class="{
                        'text-success': option.is_online_status == 1,
                        'text-danger': option.is_online_status == 0,
                      }"
                      :title="
                        option.is_online_status == 1 ? 'Online' : 'Offline'
                      "
                      class="fa fa-signal"
                    ></i>
                  </span>
                  <span class="custom__remove" @click="remove(option)">❌</span>
                </span>
              </template>
              <template slot="clear" slot-scope="props">
                <div
                  class="multiselect__clear"
                  v-if="selectedContact.length"
                  @mousedown.prevent.stop="clearAll(props.search)"
                ></div>
              </template>
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="form-group form-focus">
            <input
              class="form-control floating"
              v-model="serverParams.columnFilters.message"
              type="text"
            />
            <label class="focus-label">Resp. Message</label>
          </div>
        </div>

        <div class="col-sm-6 col-md-3" v-show="false">
          <div class="form-group form-focus">
            <input
              class="form-control floating"
              v-model="serverParams.columnFilters.message_away"
              type="text"
            />
            <label class="focus-label">Message Away</label>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <a
            href="javascript:void(0)"
            @click.prevent="searchData"
            class="btn btn-success btn-block"
            >Search</a
          >
        </div>
      </div>
      <div class="row filter-row" v-if="selectedTable.length">
        <div class="col-sm-6 col-md-2">
          <div class="form-group">
            <button
              :disabled="isLoading"
              @click.prevent="actionDelete"
              class="btn btn-danger btn-block"
            >
              <i class="la la-trash"></i> Remove
            </button>
          </div>
        </div>
        <div class="col-sm-6 col-md-2">
          <div class="form-group">
            <button
              :disabled="isLoading"
              @click.prevent="actionDraft"
              class="btn btn-warning btn-block"
            >
              <i class="la la-pause"></i> Draft
            </button>
          </div>
        </div>
        <div class="col-sm-6 col-md-2">
          <div class="form-group">
            <button
              :disabled="isLoading"
              @click.prevent="actionPublish"
              class="btn btn-success btn-block"
            >
              <i class="la la-check"></i> Publish
            </button>
          </div>
        </div>
        <div class="col-sm-6 col-md-2">
          <div class="form-group">
            <a
              class="btn btn-success btn-block"
              @click="showBroadcast(true)"
              href="#"
              data-toggle="modal"
              data-target="#add_form_transfer"
            >
              <i class="fa fa-send"></i> Transfer
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="text-right">
            <!-- <button class="btn btn-success btn-block">Scrape</button>-->
            <a @click.prevent="hideActions" class="btn btn-xs">
              <i class="fa fa-close"></i> Close
            </a>
          </div>
        </div>
      </div>
      <!-- /Search Filter -->
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info">
            Pesan secara otomatis dikirim
            <b>berdasarkan Kata Kunci dan konsdisi yang ditentukan.</b>
          </div>
        </div>
        <div class="col-md-12">
          <!-- {{currentDateTimeUnix()}} -->
          <div class="table-responsive">
            <table class="table table-striped custom-table mb-0">
              <thead>
                <tr>
                  <th>
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="selectAllTable" />
                      </label>
                    </div>
                  </th>
                  <th>License</th>
                  <th>Title</th>
                  <th style="width: 400px">Resp. Message</th>
                  <th>Freq. per Person</th>
                  <th>Keywords</th>
                  <th style="width: 400px" v-show="false">Away Message</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="loading">
                  <tr>
                    <td colspan="8">
                      <Skeleton :count="1" />
                    </td>
                  </tr>
                </template>
                <template v-if="rows.length">
                  <tr v-for="(row, index) in rows" :key="index">
                    <td>
                      <div class="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            v-model="selectedTable"
                            :value="row"
                          />
                        </label>
                      </div>
                    </td>
                    <td class="text-wrap">
                      <span v-html="row.license_name"></span>
                    </td>
                    <td class="text-wrap">
                      <span v-html="row.title"></span>
                    </td>

                    <td class="text-wrap" style="max-width: 400px">
                      <div
                        style="
                          word-wrap: break-word;
                          white-space: initial;
                          text-align: center;
                        "
                        v-if="row.image_url != ''"
                      >
                        <span v-if="row.message_type == 'image'">
                          <img :src="row.image_url" style="width: 100px" />
                        </span>
                        <span v-else>
                          <a :href="row.image_url" target="_blank"
                            ><i class="fa fa-file"></i> File</a
                          >
                        </span>
                      </div>
                      <div style="word-wrap: break-word; white-space: initial">
                        {{ row.message }}
                      </div>
                      <div style="font-size: 12px" class="text-muted">
                        {{ row.footer_message }}
                      </div>
                      <template
                        v-if="
                          row.btn_main.length && row.button_type != 'list_text'
                        "
                      >
                        <template v-if="row.button_type == 'text_reply'">
                          <div
                            v-for="(rowVal, idx) in row.btn_main"
                            :key="idx"
                            class="user-add-shedule-list"
                          >
                            {{ idx + 1 + ". " + rowVal.button_text }}
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-for="(rowVal, idx) in row.btn_main"
                            :key="idx"
                            class="user-add-shedule-list"
                          >
                            <a href="javascript:void(0)">
                              <i
                                class="fa fa-tags"
                                v-if="rowVal.button_type == 'button'"
                              ></i>
                              <i
                                class="fa fa-external-link"
                                v-if="rowVal.button_type == 'url'"
                              ></i>
                              <i
                                class="fa fa-phone"
                                v-if="rowVal.button_type == 'call'"
                              ></i>
                              {{ rowVal.button_text }}
                            </a>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <table class="table">
                          <tr v-for="(rowVal, idx) in row.btn_main" :key="idx">
                            <td>{{ rowVal.button_text }}</td>
                            <td>
                              <input type="radio" disabled />
                            </td>
                          </tr>
                        </table>
                      </template>
                    </td>
                    <td>{{ row.frequency_per_person_label }}</td>
                    <td>
                      <span class="text-capitalize">{{ row.trigger_on }}</span>
                      Chats
                      <div
                        class="text-muted"
                        v-if="row.trigger_on == 'some'"
                        style="font-size: 10px"
                      >
                        Include people who meet <br />
                        <b class="text-uppercase">{{
                          row.trigger_on_some_type
                        }}</b>
                        of the following conditions
                        <br />
                        <a
                          @click.prevent="outputConditions(row.some_detail)"
                          ref="getConditions"
                          href="#"
                          data-toggle="modal"
                          data-target="#getConditions"
                        >
                          <i class="fa fa-gears"></i> Check Conditions
                        </a>
                      </div>
                    </td>
                    <td
                      style="max-width: 400px"
                      class="text-wrap"
                      v-show="false"
                    >
                      <div v-if="row.is_enable_away_message == 1">
                        <span
                          style="word-wrap: break-word; white-space: initial"
                          >{{ row.message_away }}</span
                        >
                        <template v-if="row.btn_away_message.length">
                          <div
                            v-for="(rowVal, idx) in row.btn_away_message"
                            :key="idx"
                            class="user-add-shedule-list"
                          >
                            <a href="javascript:void(0)">
                              <i
                                class="fa fa-tags"
                                v-if="rowVal.button_type == 'button'"
                              ></i>
                              <i
                                class="fa fa-external-link"
                                v-if="rowVal.button_type == 'url'"
                              ></i>
                              <i
                                class="fa fa-phone"
                                v-if="rowVal.button_type == 'call'"
                              ></i>
                              {{ rowVal.button_text }}
                            </a>
                          </div>
                        </template>
                        <div class="text-muted" style="font-size: 10px">
                          From {{ row.away_message_start }} to
                          {{ row.away_message_end }}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        class="badge badge-warning"
                        v-if="row.is_publish == '0'"
                      >
                        <i class="fa fa-save"></i> Draft
                      </div>
                      <div class="badge badge-success" v-else>
                        <i class="fa fa-check"></i> Published
                      </div>
                    </td>
                    <td>
                      <div class="dropdown action-label">
                        <a
                          class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                          href="#"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="fa fa-dot-circle-o text-danger"></i> Options
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="row.is_publish == 1"
                            @click.prevent="draftData(row.id)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-pause text-warning"></i> Set to
                            Draft
                          </a>
                          <a
                            v-if="row.is_publish == 0"
                            @click.prevent="publishData(row.id)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-check text-info"></i> Set to Publish
                          </a>
                          <a
                            @click.prevent="detailData(row.id)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-pencil text-success"></i> Edit
                          </a>
                          <a
                            @click.prevent="copyData(row.id)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-copy text-info"></i> Copy
                          </a>
                          <a
                            @click.prevent="deleteData(row.id)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-trash-o text-danger"></i> Remove
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else-if="rows.length < 1 && !loading">
                  <tr>
                    <td colspan="8" class="text-center">-empty-</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <span class="footer__row-count__label">Displaying</span>
          <select
            @change="onPerPageChange(serverParams.perPage)"
            autocomplete="off"
            name="perPageSelect"
            v-model="serverParams.perPage"
            style="width: 100px"
            class="select-to-paginasi"
          >
            <option value="10">10 / page</option>
            <option value="20">20 / page</option>
            <option value="30">30 / page</option>
            <option value="40">40 / page</option>
            <option value="50">50 / page</option>
          </select>
          <span class="footer__row-count__label"
            >of {{ totalRecords }} total records</span
          >
        </div>
        <div class="col-sm-12 col-md-6 text-right">
          <a
            href="javascript:void(0)"
            @click="onPrevChange(parseInt(currentPage))"
            tabindex="0"
            class="btn"
            :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
          >
            <span class="chevron left"></span>
            <span>Prev</span>
          </a>
          page
          <input
            style="width: 100px"
            min="1"
            type="number"
            v-model="currentPage"
            @keyup.enter="onPageChange(parseInt(currentPage))"
            class
          />
          of {{ Math.ceil(totalRecords / serverParams.perPage) }}
          <a
            href="javascript:void(0)"
            @click="onNextChange(parseInt(currentPage))"
            tabindex="0"
            class="footer__navigation__page-btn"
            :class="
              'btn ' +
              {
                disabled:
                  parseInt(currentPage) + 1 >
                  Math.ceil(totalRecords / serverParams.perPage),
              }
            "
          >
            <span>Next</span>
            <span class="chevron right"></span>
          </a>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
    <!-- </div> -->
    <!-- /Page Wrapper -->
    <!-- </div> -->

    <form-data :searchData="searchData" />
    <form-transfer :searchData="searchData" :selectedTable="selectedTable" />

    <!-- {{selectedContact}} -->

    <div id="getConditions" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detail Conditions</h5>
            <!-- {{broadcastParam.broadcast_id}} -->
            <button
              ref="dismisModal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center">Select Variable</th>
                  <th class="text-center">Condition</th>
                  <th class="text-center">Text</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rowCond, idx) in this.currentConditions" :key="idx">
                  <td class="text-center text-muted">
                    {{ rowCond.select_variable }}
                  </td>
                  <td class="text-center text-muted">
                    {{ rowCond.condition }}
                  </td>
                  <td class="text-center uk-text-bold">{{ rowCond.text }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <v-tour
      name="tourGuide"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid,
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import FormTransfer from "./formTransfer.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormData,
    FormTransfer,
  },
  data() {
    return {
      numPendingTransfer: 0,
      tourId: "sar.home",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete,
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Fitur yang memungkinkan Kamu untuk membuat sebuah pesan jawaban otomatis setiap ada Customer yang mengirimkan pesan kepada nomor WhatsApp Kamu.`,
        },
        {
          target: '[data-tour-step="2"]',
          content: "Untuk membuat pesan Smart Auto Reply baru.",
        },
        {
          target: '[data-tour-step="3"]',
          content: "Filter pencarian.",
          params: {
            placement: "top",
          },
        },
      ],
      selectedTable: [],
      currentConditions: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20,
      },
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          license_id: "",
          message: "",
          message_away: "",
          trigger_on: "some",
        },
        page: 1,
        perPage: 20, // perPage
      },
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      },
    },
  },
  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.license_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.license_id = "";
          this.searchData();
        }
      },
      deep: true,
    },
  },
  created() {
    this.asyncFind("");
    this.loadItems();
    this.currentPage = this.serverParams.page;
    this.tourDetail();

    this.$store
      .dispatch("automation/countPendingTransferSmartReply")
      .then((response) => {
        this.numPendingTransfer = response.data;
        // console.log("query: ", query);
        // console.log("contactOptions: ", this.contactOptions);
      });
  },
  methods: {
    tourShow() {
      this.$tours["tourGuide"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId,
      };
      this.$store.dispatch("tour/tourDetail", params).then((response) => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionPublish() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to change status of the " +
          this.selectedTable.length +
          " messages to Publish?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionPublishSmartAutoReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Publish",
                  text: "The data was successfully change to Publish",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    actionDraft() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to change status of the " +
          this.selectedTable.length +
          " messages to Draft?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionDraftSmartAutoReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Draft",
                  text: "The data was successfully change to Draft",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000,
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      })
        .then(async (r) => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
            };
            this.$store
              .dispatch("automation/actionDeleteSmartAutoReply", newParam)
              .then((response) => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000,
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch((e) => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    outputConditions(conditions) {
      this.currentConditions = [];
      if (conditions.length > 0) {
        this.currentConditions = conditions;
      }
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then((response) => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id,
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailSmartReplyForEdit", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          data.header.is_custom_url = false;
          data.header.is_enable_attach_file = false;
          if (data.header.image_url != "") {
            data.header.is_enable_attach_file = true;
          }
          formData = data;
        });
      // console.log("formData::", formData);
      // formData.id = id;
      await this.$store.dispatch("automation/actFormParamSRSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    async copyData(id) {
      //set false dulu
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id,
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailSmartReplyForEdit", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          formData = data;
        });
      // console.log("formData::", formData);
      formData.header.copy = true;
      await this.$store.dispatch("automation/actFormParamSRSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    draftData(id) {
      let dataParam = {};
      dataParam = {
        id: id,
      };
      this.$store
        .dispatch("automation/updateSmartReplyDraft", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000,
          });
        });
    },
    publishData(id) {
      let dataParam = {};
      dataParam = {
        id: id,
      };
      this.$store
        .dispatch("automation/updateSmartReplyPublish", dataParam) // sesuai kan dengan method di API
        .then((response) => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000,
          });
        });
    },
    deleteData(id) {
      this.$fire({
        title: "Are you sure you will delete this data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            id: id,
          };
          this.$store
            .dispatch("automation/deleteSmartReply", dataParam) // sesuai kan dengan method di API
            .then((response) => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              });
            });
        }
      });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);
        this.selectedLicense = [];

        let formData = {
          header: {
            id: "",
            license_id: "",
            message: "",
            trigger_on: "all",
            trigger_on_some_type: "any",
            frequency_per_person: 15,
            is_enable_away_message: 0,
            is_enable_away_message_status: false,
            message_away: "",
            footer_message: "",
            footer_message_status: false,
          },
          detail_button: [
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
          ],
          detail_button_away: [
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
            {
              auto_reply_button_id: "",
            },
          ],
          detail_some: [
            {
              select_variable: "conversation",
              condition: "start_with",
              text: "",
            },
          ],
          start_away: "19:00",
          end_away: "08:00",
        };
        this.$store.dispatch("automation/actFormParamSRSt", formData);
      }
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage,
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("automation/listSmartReply", this.serverParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list",
};
</script>



// WEBPACK FOOTER //
// src/views/automation/customByKeywords/list.vue